import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';
import { studyFilter, filterPrescreened, applicantsFilter, questionFilter } from 'src/app/model/gridFilter.model';

interface UserPreferencesState {
  studiesLibrary: studyFilter;
  preScreenedLibrary: filterPrescreened;
  applicants: applicantsFilter;
  questionLibrary: questionFilter;
}

const initialState: UserPreferencesState = {
  studiesLibrary: new studyFilter(),
  preScreenedLibrary: new filterPrescreened(),
  applicants: new applicantsFilter(),
  questionLibrary: new questionFilter()
};

export const UserPreferencesStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setStudiesLibraryFilter(filter: studyFilter) {
      patchState(store, { studiesLibrary: filter });
    },
    updateStudiesLibraryFilter(updates: Partial<studyFilter>) {
      patchState(store, { 
        studiesLibrary: { ...store.studiesLibrary(), ...updates }
      });
    },
    setPreScreenedLibraryFilter(filter: filterPrescreened) {
      patchState(store, { preScreenedLibrary: filter });
    },
    updatePreScreenedLibraryFilter(updates: Partial<filterPrescreened>) {
      patchState(store, { 
        preScreenedLibrary: { ...store.preScreenedLibrary(), ...updates }
      });
    },
    setApplicantsFilter(filter: applicantsFilter) {
      patchState(store, { applicants: filter });
    },
    updateApplicantsFilter(updates: Partial<applicantsFilter>) {
      patchState(store, { 
        applicants: { ...store.applicants(), ...updates }
      });
    },
    setQuestionLibraryFilter(filter: questionFilter) {
      patchState(store, { questionLibrary: filter });
    },
    updateQuestionLibraryFilter(updates: Partial<questionFilter>) {
      patchState(store, { 
        questionLibrary: { ...store.questionLibrary(), ...updates }
      });
    },
    resetStudiesLibraryFilter() {
      patchState(store, { studiesLibrary: new studyFilter() });
    },
    resetPreScreenedLibraryFilter() {
      patchState(store, { preScreenedLibrary: new filterPrescreened() });
    },
    resetApplicantsFilter() {
      patchState(store, { applicants: new applicantsFilter() });
    },
    resetQuestionLibraryFilter() {
      patchState(store, { questionLibrary: new questionFilter() });
    },
    resetAllFilters() {
      patchState(store, initialState);
    }
  }))
);
